import {Drawer} from '@mui/material';
import {Snackbar} from 'presentation/components';
import {Drawer as DrawerCustom} from 'presentation/components/Drawer';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {Fragment, useState} from 'react';
import {useSearchProviders} from 'presentation/pages/private/authorizations/hooks/useSearchProviders';
import {Provider} from '../ProviderList/types';
import {DrawerContent} from './DrawerContent';
import {ProviderDrawerProps} from './types';

const {
	providerDrawer: {maxLimitMessage},
	removedProvider,
} = translations['pt-br'].privateFlow.requestAuthorizations.request.ProviderSelection;
const {added} = translations['pt-br'].commons;

export function ProviderDrawer({
	openDrawer,
	onOpenDrawer,
	onCloseDrawer,
	selectedState,
	setSelectedState,
}: ProviderDrawerProps) {
	const {isMobile} = useMediaQueries();
	const [showSnackbarState, setShowSnackbarState] = useState(false);
	const [snackbarMessageState, setSnackbarMessageState] = useState('');

	const {clearSearchParams} = useSearchProviders();

	const handleToggleProvider = (provider: Provider) => {
		setSelectedState(prev => {
			const alreadySelected = prev.some(p => p.idUnico === provider?.idUnico);

			setShowSnackbarState(true);
			if (alreadySelected) {
				setSnackbarMessageState(removedProvider);
				return prev.filter(p => p.idUnico !== provider?.idUnico);
			}

			if (prev.length >= 3) {
				setSnackbarMessageState(maxLimitMessage);
				return prev;
			}

			setSnackbarMessageState(`${added} (${selectedState.length + 1}/3)`);
			return [...prev, provider];
		});
	};

	const handleCloseDrawer = () => {
		clearSearchParams();
		onCloseDrawer();
	};

	return (
		<Fragment>
			{isMobile ? (
				<Drawer open={openDrawer} onClose={handleCloseDrawer}>
					<DrawerContent
						selectedProviderList={selectedState}
						onCloseDrawer={handleCloseDrawer}
						handleToggleProvider={handleToggleProvider}
					/>
				</Drawer>
			) : (
				<DrawerCustom.Root
					open={openDrawer}
					onClose={handleCloseDrawer}
					onOpen={onOpenDrawer}
					width={'792px'}>
					<DrawerContent
						selectedProviderList={selectedState}
						onCloseDrawer={handleCloseDrawer}
						handleToggleProvider={handleToggleProvider}
					/>
				</DrawerCustom.Root>
			)}

			{showSnackbarState ? (
				<Snackbar
					message={snackbarMessageState}
					open={showSnackbarState}
					onClose={() => setShowSnackbarState(false)}
					autoHideDuration={1000}
					sx={{mb: '66px'}}
				/>
			) : null}
		</Fragment>
	);
}
